import type { Album } from '../interfaces/albums';
import type { Artist } from '../interfaces/artist';
import type { Playlist } from '../interfaces/playlists';
import { Track } from '../interfaces/track';

export const removeHtmlTags = (html: string) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

export const getItemDescription = (item: any) => {
  if (item.type === 'playlist') {
    return getPlaylistDescription(item);
  }
  if (item.type === 'album') {
    return getAlbumDescription(item);
  }
  if (item.type === 'artist') {
    return item.genres?.slice(0, 2).join(', ') ?? '';
  }
  return '';
};

export const getPlaylistDescription = (item: any) => {
  if (item.type === 'playlist') {
    return removeHtmlTags(item.description || '');
  }
  return '';
};

export const getAlbumDescription = (item: any) => {
  if (item.type === 'album') {
    const year = item.release_date ? String(item.release_date).split('-')[0] : '';
    const type = item.album_type === 'album' ? 'Album' : 'Single';
    return year ? `${year} • ${type}` : type;
  }
  return '';
};
